import { Rate } from '@mortgage-pos/types'

export default {
  monthlyPayment: (rate: Rate) => ({
    title: 'Monthly Payment',
    text: `This represents your monthly principal plus interest. If you choose to escrow your taxes and insurance, your total estimated monthly payment will be $${Intl.NumberFormat(
      'en-US'
    ).format(Math.round(rate.monthlyPayment))}`,
  }),
  apr: {
    title: 'APR (Annual Percentage Rate)',
    text: 'APR (Annual Percentage Rate) is a percentage that represents the total cost of your loan over its term, expressed as a percentage. This is a combination of your interest rate, fees and upfront costs so you can easily compare the total cost of loans.',
  },
  upfront: {
    title: 'Upfront costs',
    text: 'This is how much will be charged for originating the loan, and includes fees, application and processing costs, underwriting and more. This may not include all costs associated with your loan. Tell your loan officer if you’d like to roll these costs into your total loan amount.',
  },
  rates: {
    title: 'Rate',
    text: "Similar to other loans, this is how much you'll pay to borrow the money for your loan each year.",
  },
  points: {
    title: 'Points',
    text: 'With points, you pay more upfront in exchange for a lower interest rate over the life of your loan',
  },
  costOfMortgage: {
    title: 'Cost of Mortgage over 5 yrs.',
    text: "This shows the estimated amount you'll have paid in upfront costs and interest over 5 years.",
  },
  costOfMortgage8Years: {
    title: 'Cost of Mortgage over 8 yrs.',
    text: "This shows the estimated amount you'll have paid in upfront costs and interest over 8 years.",
  },
}
